export const getColor = (value = 0) => {
  const saturation = "100%";
  const lightness = "35%";

  return `hsl(${value}, ${saturation}, ${lightness})`;
};
